import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AppRequestContextService } from '../../../app-request-context.service';
import { ApiV1_Category } from '@pedix-workspace/api-v1';

export const categoryResolverFn: ResolveFn<ApiV1_Category> = (
  routeSnapshot: ActivatedRouteSnapshot,
) => {
  const appRequestContext = inject(AppRequestContextService);

  const { categoryId } = routeSnapshot.params;

  const category = appRequestContext.allCategories().find(c => {
    return categoryId === c.id || categoryId === c.slug;
  });

  return category;
};
